/* eslint-disable no-console */
/**
 * Quantity tier selector (custom dropdown).
 * - Trigger button opens the listbox.
 * - Clicking an option selects it, writes to the hidden qty input, closes.
 * - ESC closes. Click-outside closes.
 * - Highlights the matching row in any nearby volume-pricing ladder.
 */
(function () {
  if (typeof document === 'undefined') return;

  function inEditor() {
    return !!(window.Shopify && (window.Shopify.designMode || window.Shopify.themeEditor));
  }

  function findQtyInput(scope) {
    return scope.querySelector('.quantity-tier-selector__qty-input') || null;
  }

  function findLadder() {
    return document.querySelector('[data-volume-ladder]');
  }

  function syncLadder(qty) {
    var ladder = findLadder();
    if (!ladder) return;
    var rows = ladder.querySelectorAll('[data-qty]');
    var bestBelow = null;
    rows.forEach(function (row) {
      var rq = parseInt(row.getAttribute('data-qty') || '0', 10);
      row.classList.remove('is-active');
      if (rq > 0 && rq <= qty) {
        if (!bestBelow || rq > parseInt(bestBelow.getAttribute('data-qty') || '0', 10)) {
          bestBelow = row;
        }
      }
    });
    if (bestBelow) bestBelow.classList.add('is-active');
  }

  function closeList(root) {
    var list = root.querySelector('[data-list]');
    var trigger = root.querySelector('[data-trigger]');
    if (list) list.setAttribute('hidden', '');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function openList(root) {
    var list = root.querySelector('[data-list]');
    var trigger = root.querySelector('[data-trigger]');
    if (list) list.removeAttribute('hidden');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.focus();
    }
  }

  function selectOption(root, option) {
    var qty = findQtyInput(root);
    if (!qty || !option) return;
    var value = option.getAttribute('data-value') || '1';
    var v = parseInt(value, 10);
    if (isNaN(v) || v <= 0) return;

    qty.value = String(v);
    qty.dispatchEvent(new Event('change', { bubbles: true }));

    var display = root.querySelector('[data-display]');
    if (display) {
      var orig = option.getAttribute('data-orig') || '';
      var sale = option.getAttribute('data-sale') || '';
      var showStrike = root.getAttribute('data-show-strike') !== 'false';
      var txt = String(v) + ' - ';
      var origText = '';
      if (orig && orig !== '0.00') {
        var cents = Math.round(parseFloat(orig) * 100);
        var euros = Math.floor(cents / 100);
        var remCents = cents - euros * 100;
        origText = '€' + euros + (remCents > 0 ? '.' + (remCents < 10 ? '0' + remCents : remCents) : '');
      }
      var cents2 = Math.round(parseFloat(sale) * 100);
      var euros2 = Math.floor(cents2 / 100);
      var remCents2 = cents2 - euros2 * 100;
      var saleText = '€' + euros2 + (remCents2 > 0 ? '.' + (remCents2 < 10 ? '0' + remCents2 : remCents2) : '');
      if (showStrike && origText) {
        display.innerHTML = String(v) + ' - <s style="text-decoration:line-through;">' + origText + '</s> ' + saleText;
      } else {
        display.textContent = String(v) + ' - ' + saleText;
      }
    }

    var options = root.querySelectorAll('[data-list] li');
    options.forEach(function (o) {
      o.classList.toggle('is-selected', o === option);
      o.setAttribute('aria-selected', o === option ? 'true' : 'false');
    });

    syncLadder(v);
    closeList(root);
  }

  function initOne(root) {
    if (root.__tierBound) return;
    root.__tierBound = true;

    var trigger = root.querySelector('[data-trigger]');
    var list = root.querySelector('[data-list]');
    if (!trigger || !list) return;

    var qty = findQtyInput(root);

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeList(root);
      else openList(root);
    });

    var options = list.querySelectorAll('li');
    options.forEach(function (opt, idx) {
      opt.setAttribute('tabindex', '-1');
      opt.setAttribute('aria-selected', opt.classList.contains('is-selected') ? 'true' : 'false');
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        selectOption(root, opt);
      });
      opt.addEventListener('mouseenter', function () { opt.focus(); });
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openList(root);
        var first = list.querySelector('.is-selected') || options[0];
        if (first) first.focus();
      }
    });

    list.addEventListener('keydown', function (e) {
      var focusIdx = -1;
      options.forEach(function (o, i) { if (o === document.activeElement) focusIdx = i; });
      if (e.key === 'Escape') {
        e.preventDefault();
        closeList(root);
        trigger.focus();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = options[Math.min(focusIdx + 1, options.length - 1)];
        if (next) next.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = options[Math.max(focusIdx - 1, 0)];
        if (prev) prev.focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (focusIdx >= 0) selectOption(root, options[focusIdx]);
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeList(root);
    });

    if (qty) {
      var initial = parseInt(qty.value || '1', 10);
      if (!isNaN(initial) && initial > 0) syncLadder(initial);
    }
  }

  function init() {
    document.querySelectorAll('[data-quantity-tier-selector]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();